import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import Drawer from 'Components/Drawer';
import Panel from 'Components/Panel';
import TabsToolbar from 'Components/TabsToolbar';
import React from 'react';
import { HEADER_HEIGHT, SPACER_MINI, TABS_HEIGHT } from 'utils/ui/constants';
import icons from 'utils/ui/icons';
import CameraModal from './CameraModal';
import FinalReport from './FinalReport';
import Validations from './Validations';

const MainContainer = styled(Grid)(({ theme }) => ({
    height: `calc(100vh - ${HEADER_HEIGHT}px)`,
    backgroundColor: theme.palette.backgrounds.color.main,
    padding: '0px 10px 0px'
}));

const HeaderContainer = styled(Grid)(() => ({
    height: `${TABS_HEIGHT + SPACER_MINI}px`
}));

const BottomContainer = styled(Grid)(() => ({
    height: `calc(100% - ${TABS_HEIGHT + SPACER_MINI + SPACER_MINI}px)`,
    paddingBottom: 5,
    overflowY: 'auto'
}));

export const PanelButton = ({ children, disabled, onClick }) => (
    <Button color="primary" disabled={disabled} onClick={onClick} size="small" sx={{ fontSize: '0.65rem', padding: '2px 10px', minWidth: 0 }} variant="contained">{children}</Button>
);

export const PanelHeader = ({ action, children }) => (
    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>{children}</span>
        {action}
    </span>
);

// The drawer chrome both screens share; the screen brings its own panels as children.
const VerificationShell = props => {
    const { children, device, finalReportReady, primaryTab = { text: 'Primary Verification', id: 'primary-verification' }, screen, tabs = [] } = props;
    const { onDrawerClose } = props;
    const { currentVerification, drawerOpen, finalComments, finalStatus, finalValidated, showCameraModal, submitting, technicianValidated, verificationNumber, verificationsIndex } = screen;
    const { handleClean, handleDelete, handleFinalValidation, handleSaveImage, handleSelect, setFinalComments, setFinalStatus, setShowCameraModal } = screen;

    const finalValidationAction = !finalValidated && (
        <span style={{ paddingRight: 20 }}><PanelButton disabled={!finalStatus || submitting} onClick={handleFinalValidation}>Final Validation</PanelButton></span>
    );

    return (
        <>
            <Validations device={device} onClean={handleClean} onSelect={handleSelect} verificationsIndex={verificationsIndex}/>
            <Drawer onClose={onDrawerClose} open={drawerOpen} width="80vw">
                <MainContainer container>
                    <HeaderContainer size={12}>
                        <TabsToolbar
                            buttons={[
                                { icon: icons.back, onClick: onDrawerClose, tooltip: 'Close' },
                                ...(currentVerification && !technicianValidated ? [{
                                    icon: icons.trash,
                                    confirmationHeader: 'Delete Confirmation',
                                    confirmationText: 'Are you sure you want to delete this verification?',
                                    onClick: handleDelete,
                                    tooltip: 'Delete verification'
                                }] : [])
                            ]}
                            tabs={[
                                ...(finalReportReady ? [{ text: 'Final Report', id: 'final-report' }] : []),
                                primaryTab,
                                ...tabs
                            ]}
                        />
                    </HeaderContainer>
                    <BottomContainer size={12}>
                        {finalReportReady && (
                            <div id="final-report" style={{ margin: '8px 0' }}>
                                <Panel
                                    header={
                                        <PanelHeader action={finalValidationAction}>
                                            {`Final Report #${verificationNumber}`}
                                        </PanelHeader>
                                    }
                                >
                                    <FinalReport
                                        finalComments={finalComments}
                                        finalStatus={finalStatus}
                                        finalValidated={finalValidated}
                                        onFinalCommentsChange={setFinalComments}
                                        onFinalStatusChange={setFinalStatus}
                                    />
                                </Panel>
                            </div>
                        )}
                        {children}
                    </BottomContainer>
                </MainContainer>
                <CameraModal
                    onClose={() => setShowCameraModal(false)}
                    onSave={handleSaveImage}
                    open={showCameraModal}
                />
            </Drawer>
        </>
    );
};

export default VerificationShell;
